export const SALE_YESTERDAY_DOWN_KEY = 'spu.SALE_YESTERDAY_OUT_COMBO DESC, spu.ID DESC'
export const SALE_YESTERDAY_UP_KEY = 'spu.SALE_YESTERDAY_OUT_COMBO ASC, spu.ID DESC'
export const SALE_THREE_DOWN_KEY = 'spu.SALE_THREE_OUT_COMBO DESC, spu.ID DESC'
export const SALE_THREE_UP_KEY = 'spu.SALE_THREE_OUT_COMBO ASC, spu.ID DESC'
export const SALE_SEVEN_DOWN_KEY = 'spu.SALE_SEVEN_OUT_COMBO DESC, spu.ID DESC'
export const SALE_SEVEN_UP_KEY = 'spu.SALE_SEVEN_OUT_COMBO ASC, spu.ID DESC'
export const SALE_FIFTEEN_DOWN_KEY = 'spu.SALE_FIFTEEN_OUT_COMBO DESC, spu.ID DESC'
export const SALE_FIFTEEN_UP_KEY = 'spu.SALE_FIFTEEN_OUT_COMBO ASC, spu.ID DESC'
export const SALE_THIRTY_DOWN_KEY = 'spu.SALE_THIRTY_OUT_COMBO DESC, spu.ID DESC'
export const SALE_THIRTY_UP_KEY = 'spu.SALE_THIRTY_OUT_COMBO ASC, spu.ID DESC'

export const SALE_YESTERDAY_BY_BLACK_DOWN_KEY = 'SALE_YESTERDAY DESC'
export const SALE_YESTERDAY_BY_BLACK_UP_KEY = 'SALE_YESTERDAY ASC'
export const SALE_THREE_BY_BLACK_DOWN_KEY = 'SALE_THREE DESC'
export const SALE_THREE_BY_BLACK_UP_KEY = 'SALE_THREE ASC'
export const SALE_SEVEN_BY_BLACK_DOWN_KEY = 'SALE_SEVEN DESC'
export const SALE_SEVEN_BY_BLACK_UP_KEY = 'SALE_SEVEN ASC'
export const SALE_FIFTEEN_BY_BLACK_DOWN_KEY = 'SALE_FIFTEEN DESC'
export const SALE_FIFTEEN_BY_BLACK_UP_KEY = 'SALE_FIFTEEN ASC'
export const SALE_THIRTY_BY_BLACK_DOWN_KEY = 'SALE_THIRTY DESC'
export const SALE_THIRTY_BY_BLACK_UP_KEY = 'SALE_THIRTY ASC'
export const SALE_NINETY_BY_BLACK_DOWN_KEY = 'SALE_NINETY DESC'
export const SALE_NINETY_BY_BLACK_UP_KEY = 'SALE_NINETY ASC'
export const SALE_HUNDRED_EIGHTY_BY_BLACK_DOWN_KEY = 'SALE_HUNDRED_EIGHTY DESC'
export const SALE_HUNDRED_EIGHTY_BY_BLACK_UP_KEY = 'SALE_HUNDRED_EIGHTY ASC'
export const SALE_ONE_YEAR_BY_BLACK_DOWN_KEY = 'SALE_ONE_YEAR DESC'
export const SALE_ONE_YEAR_BY_BLACK_UP_KEY = 'SALE_ONE_YEAR ASC'

export const SPU_CREATED_DOWN_KEY = 'spu.CREATED DESC, spu.ID ASC' // 平台商品spu创建时间降序
export const SPU_CREATED_UP_KEY = 'spu.CREATED ASC, spu.ID ASC' // 平台商品spu创建时间升序

export const SKU_CREATED_DOWN_KEY = 'sku.CREATED DESC, sku.SORTED, sku.COLOUR, sku.SPEC' // 平台商品sku创建时间降序
export const SKU_CREATED_UP_KEY = 'sku.CREATED ASC, sku.SORTED, sku.COLOUR, sku.SPEC' // 平台商品sku创建时间升序
export const SKU_ITEM_CODE_DOWN_KEY = 'sku.ITEM_CODE desc' // 平台商品编码创建时间降序
export const SKU_ITEM_CODE_UP_KEY = 'sku.ITEM_CODE asc' // 平台商品编码创建时间升序

export const PARTNER_SPU_SHELVES_TIME_DOWN_KEY = 'partnerSpu.SHELVES_TIME DESC, partnerSpu.ID ASC' // 分销商品-按款-加入时间降序
export const PARTNER_SPU_SHELVES_TIME_UP_KEY = 'partnerSpu.SHELVES_TIME ASC, partnerSpu.ID ASC' // 分销商品-按款-加入时间升序
export const PARTNER_SPU_SHELVES_PRICE_DOWN_KEY = 'partnerSpu.SHELVES_PRICE DESC, partnerSpu.ID ASC' // 分销商品-按款-铺货价降序
export const PARTNER_SPU_SHELVES_PRICE_UP_KEY = 'partnerSpu.SHELVES_PRICE ASC, partnerSpu.ID ASC' // 分销商品-按款-铺货价升序

export const CREATED_DOWN_KEY = 'spu.CREATED DESC, spu.ID ASC'
export const CREATED_UP_KEY = 'spu.CREATED ASC, spu.ID ASC'

export const MIN_COST_PRICE_DOWN_KEY = 'spu.MIN_COST_PRICE DESC, spu.ID DESC'
export const MIN_COST_PRICE_UP_KEY = 'spu.MIN_COST_PRICE ASC, spu.ID DESC'

export const LAST_PURCHASE_PRICE_CHANGE_UP_KEY = 'purchasePriceQueryTimeSort.ASC'
export const LAST_PURCHASE_PRICE_CHANGE_DOWN_KEY = 'purchasePriceQueryTimeSort.DESC'

export const saleSort = [
    {
        key: SALE_YESTERDAY_BY_BLACK_DOWN_KEY,
        label: '昨日销量从高到低'
    },
    {
        key: SALE_YESTERDAY_BY_BLACK_UP_KEY,
        label: '昨日销量从低到高'
    },
    {
        key: SALE_THREE_BY_BLACK_DOWN_KEY,
        label: '近3日销量从高到低'
    },
    {
        key: SALE_THREE_BY_BLACK_UP_KEY,
        label: '近3日销量从低到高'
    },
    {
        key: SALE_SEVEN_BY_BLACK_DOWN_KEY,
        label: '近7日销量从高到低'
    },
    {
        key: SALE_SEVEN_BY_BLACK_UP_KEY,
        label: '近7日销量从低到高'
    },
    {
        key: SALE_FIFTEEN_BY_BLACK_DOWN_KEY,
        label: '近15日销量从高到低'
    },
    {
        key: SALE_FIFTEEN_BY_BLACK_UP_KEY,
        label: '近15日销量从低到高'
    },
    {
        key: SALE_THIRTY_BY_BLACK_DOWN_KEY,
        label: '近30日销量从高到低'
    },
    {
        key: SALE_THIRTY_BY_BLACK_UP_KEY,
        label: '近30日销量从低到高'
    }
]

export const sortList = [
    {
        name: '按创建时间排序',
        value: [
            {
                name: 'time',
                type: 'default',
                describe: '默认',
                icon: 'icon-paixu-lan',
                value: ''
            },
            {
                name: 'time',
                type: 'down',
                describe: '最大',
                icon: 'icon-paixu-lan1',
                value: CREATED_DOWN_KEY
            },
            {
                name: 'time',
                type: 'up',
                describe: '最小',
                icon: 'icon-paixu-lan2',
                value: CREATED_UP_KEY
            }
        ]
    },
    {
        name: '按成本价排序',
        value: [
            {
                name: 'sale',
                type: 'default',
                describe: '默认',
                icon: 'icon-paixu-lan',
                value: ''
            },
            {
                name: 'sale',
                type: 'down',
                describe: '最大',
                icon: 'icon-paixu-lan1',
                value: MIN_COST_PRICE_DOWN_KEY
            },
            {
                name: 'sale',
                type: 'up',
                describe: '最小',
                icon: 'icon-paixu-lan2',
                value: MIN_COST_PRICE_UP_KEY
            }
        ]
    }
]
